import React, { FC, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import useCartModelDisplay from '../../../../../hooks/useCartModelDisplay';
import ProductImageSelect from '../../../../common/Form/FormFields/ProductImageSelect/ProductImageSelect';
import Product from '../../../../../@types/Product';

interface CartProductLiftKitProps {
  retailConfigurator: boolean,
  hideAllPrices: boolean,
}

const CartProductLiftKit: FC<CartProductLiftKitProps> = ({ retailConfigurator, hideAllPrices }) => {
  const { setValue, getValues } = useFormContext();
  const currentCart = getValues();
  const editable = currentCart?.isFromInventory
      ? (currentCart?.liftKitEditable ?? false)
      : true;
  const { chassisType, setLiftKit } = useCartModelDisplay();
  const liftKit: Product | undefined = useWatch({ name: 'liftKit' });

  useEffect(() => {
    setLiftKit(liftKit);
  }, [liftKit, setValue]);

  return (
    <ProductImageSelect
      disableImageZoom={true}
      name="liftKit"
      label="Lift Kit"
      displayLabel={false}
      displayPrice={!hideAllPrices}
      disabled={!editable}
      productAlignment='left'
      displayRetailPrice={retailConfigurator}
      products={chassisType?.liftKitOptions ?? []} />
  );
}

export default CartProductLiftKit;
